import videojs from 'video.js';

export class PostPresentationLinkPluginStub extends videojs.getPlugin('plugin') {
    constructor(player, options) {
        super(player, options);

        player.loader().onLoadPresentation(onLoadPresentation.bind(player));
    }
}

function shouldLoad(presentationId, playCoverData, presentationData) {
    const { playerExtensions } = presentationData;
    return playerExtensions?.some(ext => ext.ExtensionType === 'Mediasite.Player.SurveyExtension');
}

async function onLoadPresentation(presentationId, playCoverData, presentationData) {
    const player = this;
    if (shouldLoad(...arguments)) {
        if (!videojs.getPlugin('postPresentationLink')) {
            const { PostPresentationLinkPlugin } = await import(/* webpackChunkName: 'post-presentation-link' */ './post-presentation-link.js');
            player.registerPlugin('postPresentationLink', PostPresentationLinkPlugin);
        }
        
        const { playerExtensions } = presentationData;
        const surveyExtensionConfig = playerExtensions?.find(ext => ext.ExtensionType === 'Mediasite.Player.SurveyExtension');

        const { URL: surveyUrl, Message: surveyMessage } = JSON.parse(surveyExtensionConfig?.Data ?? '{}');

        player.postPresentationLink().init({ url: surveyUrl, message: surveyMessage });
    }
}
